import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-office-asset-tab" }
const _hoisted_2 = { class: "d-flex d-flex-row-reverse" }

import {computed, onBeforeMount, reactive, ref, watch} from "vue";
import Api from "@/http/modules";
import tbMix from "@/global_mixin/tableMixin";
import {ElMessage, ElMessageBox, UploadUserFile} from "element-plus";


export default /*#__PURE__*/_defineComponent({
  props: {
    type: null
  },
  setup(__props: any) {

const props = __props as {
  type: string
}



const {
  //创建
  "POST/office/asset/task/my_assets": taskMyAssetApi,
  "POST/office/asset/task/batch_confirm_assets": batchConfirmAssetApi,
  "POST/office/asset/task/confirm_asset": confirmAssetApi
} = Api
const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(taskMyAssetApi)
onBeforeMount(() => {
  fetchData({type: props.type, filterTask:false})
})


const rowClass = (data: { row: any, rowIndex: number, }) => {
  if (needHighlight(data.row)) {
    return "bg-highlight"
  } else {
    return "no-bg-highlight"
  }
}

const needHighlight = (row: any) => {
  return parseFloat(row.purchasingPrice.replace(",", "")) > parseFloat(row.categoryLimitPrice.replace(",", ""))
}




return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        ref: "myOfficeAssetTbEle",
        border: "",
        class: "mt-15 myOfficeAssetTb",
        data: _unref(MI_tableData),
        stripe: "",
        "row-key": "id",
        "max-height": _unref(MI_height) - 100 + 'px',
        "row-class-name": rowClass
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "固定资产编号",
            prop: "no",
            "min-width": "210",
            fixed: ""
          }),
          _createVNode(_component_el_table_column, {
            label: "所属团队",
            prop: "orgName",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "所属公司",
            prop: "companyName",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "资产名称",
            prop: "name",
            "min-width": "120",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "规格型号",
            prop: "spec",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "电脑设备ID",
            prop: "deviceId",
            "min-width": "140",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "资产类别",
            prop: "categoryName",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "单位",
            prop: "unit",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "领用日期",
            prop: "ownerDate",
            "min-width": "120",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "领用人",
            prop: "ownerName",
            "min-width": "160",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "资产变动单号",
            prop: "lastAssetChangeNo",
            "min-width": "210",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "使用状态",
            prop: "statusDesc",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "存放位置",
            prop: "place",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "管理员",
            prop: "managerName",
            "min-width": "160",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "采购日期",
            prop: "purchasingDate",
            "min-width": "120",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "采购人",
            prop: "purchasingUserName",
            "min-width": "160",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "采购价格",
            prop: "purchasingPrice",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "备注",
            prop: "note",
            "min-width": "100",
            "show-overflow-tooltip": ""
          })
        ]),
        _: 1
      }, 8, ["data", "max-height"])), [
        [_directive_loading, _unref(MI_identify)]
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_pagination, {
          disabled: _unref(MI_identify),
          background: "",
          small: "",
          total: _unref(MI_total),
          currentPage: _unref(page),
          "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
          "page-size": _unref(size),
          "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
          class: "mt-10",
          "page-sizes": [10, 30, 50, 100, 300, 1000],
          layout: "sizes, prev, pager, next, total, jumper",
          onCurrentChange: _unref(MI_pageChange),
          onSizeChange: _unref(MI_sizeChange)
        }, null, 8, ["disabled", "total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
      ])
    ])
  ]))
}
}

})